export var DEPLOY_DATE = new Date('2026-10-07T21:16:42+0000');
